.subheading,
.vatNote {
  text-align: center;
}

.subheading {
  margin-bottom: 2rem;
}

.plans {
  align-items: stretch;
  display: flex;
  flex-wrap: wrap;
  gap: 1.5rem;
  justify-content: center;
}

.plan {
  background: var(--color-background);
  border: 1px solid var(--color-border);
  border-radius: 8px;
  display: flex;
  flex: 1 1 260px;
  flex-direction: column;
  gap: 0.75rem;
  min-width: 260px;
  padding: 1.5rem;
}

.planHighlighted {
  background: var(--color-tertiary-background);
  border-width: 2px;
}

.priceValue {
  font-size: 2rem;
  font-weight: 700;
  line-height: 1;
}

.priceNote {
  color: var(--color-text-muted);
  font-size: 0.8125rem;
  margin-top: 0.25rem;
}

.featureList {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 0.5rem;
  margin: 0.75rem 0;
}

.featureItem {
  align-items: center;
  display: flex;
  gap: 0.5rem;
}

.featureItem svg {
  color: var(--color-positive);
  flex-shrink: 0;
}

.featureText {
  font-size: 0.875rem;
}

.planButton {
  margin-top: auto;
}

.planNote {
  color: var(--color-text-muted);
  font-size: 0.8125rem;
  margin: 0;
  overflow-wrap: anywhere;
}

.billingToggle {
  display: flex;
  gap: 0.25rem;
  background: var(--color-background);
  border: 1px solid var(--color-border);
  border-radius: 6px;
  padding: 0.25rem;
}

.billingOption {
  align-items: center;
  background: transparent;
  border: none;
  border-radius: 4px;
  color: var(--color-text-muted);
  cursor: pointer;
  display: flex;
  flex: 1;
  font-size: 0.8125rem;
  gap: 0.375rem;
  justify-content: center;
  padding: 0.375rem 0.5rem;
  transition: background 0.15s, color 0.15s;
}

.billingOptionActive {
  background: var(--color-primary);
  color: var(--color-text-on-primary);
}

.badge {
  background: var(--color-positive);
  border-radius: 3px;
  color: #fff;
  font-size: 0.6875rem;
  font-weight: 600;
  padding: 0.1rem 0.35rem;
}

.footerAction {
  display: flex;
  justify-content: center;
  margin-top: 2rem;
}

.vatNote {
  color: var(--color-text-muted);
  font-size: 0.8125rem;
  margin-top: 1.5rem;
}
